
import SimpleChartBar from "./SimpleChartBar";

const AudienceHealth = ({data, max}) => {
    return (
        <div className="stats-health">
            <div className="mb-3 d-block">
                <h6>Audience Health</h6>
                <p>A summary of your audience's evolution</p>
            </div>

            <SimpleChartBar title="Has phone" min={data?.hasPhone} max={max} color={'rgba(181,195,213,0.73)'}/>
            <SimpleChartBar title="Has mobile" min={data?.hasMobile} max={max} color={'rgba(181,195,213,0.73)'}/>
            <SimpleChartBar title="Has email" min={data?.hasEmail} max={max} color={'rgba(181,195,213,0.73)'}/>
            <SimpleChartBar title="Total segments" min={data?.totalSegments} max={max} color={'rgba(181,195,213,0.73)'}/>
        </div>
    )
}

export default AudienceHealth;